import type {TokenClaimsSerializer} from "@/generated/DjangoTypes";
import {locationAtom} from "@/store/jotaiAtoms";
import useTokenStore from "@/store/token";
import {fetchMobileAppRedirect, fetchUser} from "@/utils/loaderUtils";
import {createFileRoute, redirect} from "@tanstack/react-router";
import {getDefaultStore} from "jotai";
import {jwtDecode} from "jwt-decode";

export const Route = createFileRoute("/")({
  beforeLoad: async ({location}) => {
    const token = useTokenStore.getState().access;

    if (!token) {
      throw redirect({to: "/login", replace: true});
    }

    const justLoggedIn = sessionStorage.getItem("justLoggedIn") === "true";
    sessionStorage.removeItem("justLoggedIn");

    const routesWithoutRedirect = ["/login", "/logout", "/register"];
    const {previousRoute} = getDefaultStore().get(locationAtom);

    if (!!previousRoute && !routesWithoutRedirect.some(route => previousRoute.startsWith(route)) && justLoggedIn) {
      throw redirect({to: previousRoute, replace: true});
    }

    const claims = jwtDecode<TokenClaimsSerializer>(token);
    const agencyId = claims.agency_ids?.[0];
    const companyId = claims.sub_brand_ids?.[0];
    const isAdmin = claims.access_level === "COMPANY_ADMIN" || claims.access_level === "INFLUENCER_ADMIN";
    const isAgency = claims.access_level === "AGENCY";
    const isInfluencer = claims.access_level === "INFLUENCER";

    if (location.pathname === "/") {
      if (isInfluencer && justLoggedIn) {
        const redirectData = await fetchMobileAppRedirect();
        return window.open(redirectData.redirect, "_self");
      }

      if (isAdmin) {
        throw redirect({to: "/campaigns", replace: true});
      }

      if (isAgency && agencyId) {
        throw redirect({
          to: "/agency/$agencyId/dashboard",
          params: {agencyId},
          replace: true,
        });
      }

      if (companyId) {
        const user = await fetchUser(claims.user_id);
        const company = user.sub_brands?.[0]?.company;

        throw redirect({
          to: company.has_campaign ? "/company/$companyId/dashboard" : "/company/$companyId/welcome",
          params: {companyId: Number(companyId)},
          replace: true,
        });
      }
    }

    return;
  },
});
